import React from "react"

import id from "@irati/utils/id"
import auth from "@irati/auth"
import {doIHavePermission} from "@irati/utils/permissions/HasPermissionTo"
import {FormattedMessage} from "@irati/utils/lang"

import {DriverCellRenderer} from "../../Renderers"
import {CommentCellRenderer, SentimentCellRenderer, BookmarkCellRenderer} from "../"
import {DateCellRenderer, PB_LAST_COLUMN, PB_PROP_RIGHT} from "../../../ui/Table"
import BookmarkHeaderRenderer from "../renderers/BookmarkHeaderRenderer"
import SentimentHeaderRenderer from "../renderers/SentimentHeaderRenderer"

export const DATE_PROPERTY = "createdAt"

const setFlexHeaderStyle = (justifyContent = "flex-start", alignItems = "center") => ({
  style: {
    display: "flex",
    justifyContent,
    alignItems
  }
})

const columns = (formatMessage, idNamespace, driverCount) => {
  const cols = [
    {
      Header: <SentimentHeaderRenderer />,
      accessor: "tags",
      sortable: false,
      [PB_LAST_COLUMN]: true,
      width: 60,
      style: {padding: "20px 20px 0 0", border: "none"},
      Cell: (props) => <SentimentCellRenderer {...props} id={id("sentiment", idNamespace)} />
    },
    {
      Header: <FormattedMessage id="insights.analysis.comments.column.comment" />,
      getHeaderProps: setFlexHeaderStyle,
      accessor: "text",
      sortable: false,
      minWidth: 300,
      style: {border: "none"},
      Cell: (props) => <CommentCellRenderer {...props} id={id("text", idNamespace)} />
    },
    {
      Header: <FormattedMessage id="insights.analysis.comments.column.date" />,
      getHeaderProps: () => setFlexHeaderStyle("flex-end"),
      accessor: DATE_PROPERTY,
      Cell: (props) => <DateCellRenderer {...props} property={DATE_PROPERTY} />,
      [PB_PROP_RIGHT]: true,
      sortable: false,
      maxWidth: 150
    }
  ]

  if (driverCount > 1) {
    cols.splice(2, 0, {
      Header: <FormattedMessage id="insights.analysis.comments.column.driver" />,
      getHeaderProps: setFlexHeaderStyle,
      accessor: "driver",
      sortable: false,
      minWidth: 200,
      maxWidth: undefined,
      Cell: (props) => <DriverCellRenderer {...props} id={id("driver", idNamespace)} />
    })
  }

  if (doIHavePermission(["insights.bookmarkComments"], auth.apps())) {
    cols.push({
      Header: () => <BookmarkHeaderRenderer />,
      accessor: "tags",
      Cell: (props) => <BookmarkCellRenderer {...props} id={id("Bookmark", idNamespace)} />,
      [PB_PROP_RIGHT]: true,
      [PB_LAST_COLUMN]: true,
      sortable: false,
      width: 150
    })
  }
  return cols
}


export default columns
